import { useEffect, useState } from "react";
import { BulkMatrixType } from "../../../../../services/cellcast.v2.types";
import { useLazyGetBulkMatrixReportQuery } from "../../../../../services/cellcast.v2";
import { useSelector } from "react-redux";
import { getUserData } from "../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice";

const portelliAccount = '65dc62e384ba9801ac5bf76a';

type MatrixData = Record<
  BulkMatrixType,
  { value: number; growthRate: number; tooltipText?: string }
>;

type MatrixLoadingState = Record<BulkMatrixType, boolean>;

export const useBulkMessageMatrixReport = () => {
  const UserDetails: any = useSelector(getUserData)

  const [fetchMatrix] = useLazyGetBulkMatrixReportQuery();

  const initialData: MatrixData = {
    [BulkMatrixType.bounceRate]: {
      value: 0,
      growthRate: 0,
      tooltipText: "Bounce Rate (Month-to-Date)",
    },
    [BulkMatrixType.ctrRate]: {
      value: 0,
      growthRate: 0,
      tooltipText: "Click Through Rate (Month-to-Date)",
    },
    [BulkMatrixType.replyRate]: {
      value: 0,
      growthRate: 0,
      tooltipText: "Reply Rate (Month-to-Date)",
    },
    [BulkMatrixType.unsubscribeRate]: {
      value: 0,
      growthRate: 0,
      tooltipText: "Unsubscribe Rate (Month-to-Date)",
    },
  };

  const [matrixData, setMatrixData] = useState<MatrixData>(initialData);
  const [loadingState, setLoadingState] = useState<MatrixLoadingState>(() => ({
    [BulkMatrixType.bounceRate]: true,
    [BulkMatrixType.ctrRate]: true,
    [BulkMatrixType.replyRate]: true,
    [BulkMatrixType.unsubscribeRate]: true,
  }));

  useEffect(() => {
    if (UserDetails?.user?._id !== portelliAccount) {
      Object.values(BulkMatrixType).forEach((type) => {
        setLoadingState((prev) => ({ ...prev, [type]: true }));

        fetchMatrix({ type })
          .unwrap()
          .then((res) => {
            setMatrixData((prev) => ({
              ...prev,
              [type]: { ...prev[type], ...res.data },
            }));
          })
          .catch((err) => {
            console.error(`Failed to fetch data for ${type}:`, err);
          })
          .finally(() => {
            setLoadingState((prev) => ({ ...prev, [type]: false }));
          });
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchMatrix]);

  return { matrixData, loadingState, portelliAccount };
};